import { Route, Routes, useLocation } from "react-router-dom";
import Homepage from "./pages/Homepage";
import ContactUsPage from "./pages/ContactUsPage";
import PricingPage from "./pages/PricingPage";
import Pay from "./components/Payment/Pay";
import ServicesPage from "./pages/ServicesPage";
import Aboutus from "./pages/Aboutus";
import TermsAndServices from "./components/TermsAndServices";
import LegalDisclaimer from "./components/LegalDisclaimer";
import LogoNav from "./components/LogoNav";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import RefundPolicy from "./components/RefundPolicy";
import ServiceAgreement from "./components/ServiceAgreement";
import Grievance from "./components/Grievance";
import OurProcess from "./components/OurProcess";
import Career from "./pages/Career";
import KYC from "./pages/KYC";
import Complaints from "./pages/Complaints";
import PrivacyPolicy from "./pages/PrivacyPolicy.jsx";
import APIServices from "./pages/ApiServices.jsx";
import Disclosure from "./pages/Disclosure.jsx";
import AddressBar from "./components/AddressBar.jsx";
import SecurePayment from "./pages/SecurePayment.jsx";
import PaymentSuccess from "./pages/PaymentSucess.jsx";
import PaymentFailed from "./pages/PaymentFailed.jsx";
function App() {
  const location = useLocation();
  const HIDE_CHROME_PATHS = [
    "/secure-payment",
    "/payment-success",
    "/payment-failed",
  ];
  const hideChrome = HIDE_CHROME_PATHS.includes(location.pathname);
  return (
    <>
      <ScrollToTop />
      {!hideChrome && <AddressBar />}
      {!hideChrome && <Navbar />}
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/contactus" element={<ContactUsPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/payment" element={<Pay />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/:serviceId" element={<ServicesPage />} />
        <Route path="/termsAndCondition" element={<TermsAndServices />} />
        <Route path="/legalDisclaimer" element={<LegalDisclaimer />} />
        <Route path="/refundPolicy" element={<RefundPolicy />} />
        <Route path="/serviceAgreement" element={<ServiceAgreement />} />
        <Route path="/grievance" element={<Grievance />} />
        <Route path="/ouProcess" element={<OurProcess />} />
        <Route path="/careers" element={<Career />} />
        <Route path="/kyc" element={<KYC />} />
        <Route path="/complaint" element={<Complaints />} />
        <Route path="/service-api" element={<APIServices />} />
        <Route path="/disclosure" element={<Disclosure />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/secure-payment" element={<SecurePayment />} />
        <Route path="/payment-failed" element={<PaymentFailed />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />

      </Routes>
      {!hideChrome && <Footer />}
    </>
  );
}

export default App;
